import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './MyInfoWrite.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from "../../../../constants/url";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../../../components/comm/Modal"
import { actionLogOut, actionRemoveUser } from '../../../../assets/js/comm';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import ToastPopup from '../../../../components/comm/ToastPopup';

const MyInfoWrite = () => {
    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const navigate = useNavigate();

    //모달창
    const [isOpen, setIsOpen] = useState(false);

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const { state } = location;

    const successYn = state?.successYn ?? null;
    const successMsg = state?.successMsg ?? null;

    useEffect(() => {
        if (!successYn) return;
        setToastMessage(successMsg || "등록이 완료되었습니다.");
        setToast(true);

        navigate(location.pathname, { replace: true, state: {} });
    }, [successYn, successMsg]);

    useEffect(() => {
        if (!location.state?.cameFromNice) return;

        const onPopState = () => {
            debugger;
            navigate(URL.APP_SETTINGS, { replace: true });
        };

        window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', onPopState);

        return () => {
            window.removeEventListener('popstate', onPopState);
        };
    }, [location.state, navigate]);

    const logOutBtn = () => {
        setIsOpen(!isOpen);
    }

    const formatBrthdy = (dateStr) => {

        if (!dateStr) return '';

        return dateStr.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1.$2.$3');
    }

    /**
     * 로그아웃 액션
     */
    const handleLogout = () => {
        actionLogOut(loginUser);
    };

    const getIntegrationCryptoToken = useCallback(async () => {

        // const url = "/nice/auth/integration/crypto/token/" + (sns ? sns : 'idpw');
        //const url = `/nice/auth/integration/crypto/token/phone`;

        const query = new URLSearchParams({
            svcType: 'M',
        }).toString();

        const url = `/nice/auth/request/phone?${query}`;

        await axiosApi.post(url, {})
            .then((res) => {

                //console.log( " ==================> res : ", res );
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    // const { tokenVersionId, encData, integrityValue } = res.data.result.result;

                    // submitToNice({
                    //     action: 'https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb',
                    //     tokenVersionId: tokenVersionId,
                    //     encData: encData,
                    //     integrity: integrityValue,
                    //     service: 'm',
                    //     openPopup: false, // 팝업이 싫으면 false 주면 현재 탭에서 POST
                    // });

                    /**
                     * ==========================================
                     * [2026.02.26] NICE 본인인증 - iOS 외부링크 히스토리 오염 방지
                     * ==========================================
                     *
                     * [문제]
                     * - 기존: submitToNice()로 메인 WebView에서 form submit → NICE/PASS 외부 페이지 이동
                     * - iOS WKWebView의 backForwardList에 NICE URL이 쌓임
                     * - 인증 완료 후 돌아와도 swipe back 시 NICE 페이지로 다시 이동하는 문제
                     *
                     * [해결]
                     * - NICE 인증을 RN 측 별도 overlay WebView(NiceAuthWebView)에서 진행
                     * - 메인 WebView의 history를 오염시키지 않음
                     * - 인증 완료 후 서버 callback redirect URL을 메인 WebView에서 location.replace로 로드
                     * - NiceRedirectPage 기존 로직(getAuthResult → CI 비교 → 번호 변경) 그대로 동작
                     *
                     * [변경 파일]
                     * - React: MyInfoWrite.jsx (여기) — submitToNice() 대신 OPEN_NICE_AUTH postMessage
                     * - RN: NiceAuthWebView.js (신규) — overlay WebView 컴포넌트
                     * - RN: App.js — OPEN_NICE_AUTH message handler + overlay 렌더링
                     * - RN: injectedScripts.js — NAVIGATE_TO_PAGE pushState 충돌 제거
                     *
                     * [적용 범위]
                     * - MyInfoWrite 페이지의 휴대전화번호 변경만 적용
                     * - 회원가입 등 다른 NICE 인증 flow는 기존 submitToNice() 방식 유지
                     * ==========================================
                     */

                    const authUrl = res.data?.result?.result?.authUrl;
                    if (!authUrl) {
                        setToastMessage('인증 URL이 없습니다.');
                        setToast(true);
                        return;
                    }

                    window.location.assign(authUrl);

                    /* 스토어 배포 심사 통과하면 그때 주석 풀어야 함
                    window.ReactNativeWebView?.postMessage(JSON.stringify({
                        type: 'OPEN_NICE_AUTH',
                        payload: {
                            tokenVersionId,
                            encData,
                            integrityValue,
                        }
                    }));
                    */
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("아이핀 암호화토큰 호출 실패  : ", err);
            })
    }, []);

    const addHidden = (form, name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.id = name;
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    const submitToNice = ({ action, tokenVersionId, encData, integrity, service, openPopup = true, echo = {} }) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = action;
        // form.acceptCharset = 'UTF-8';

        if (openPopup) {
            // 팝업 차단 방지: 사용자 클릭 이벤트 안에서 window.open 먼저 호출
            window.open('', 'nicePopup', 'width=430,height=640,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes');
            form.target = 'nicePopup';
        }

        addHidden(form, 'token_version_id', tokenVersionId);
        addHidden(form, 'enc_data', encData);
        addHidden(form, 'integrity_value', integrity);
        if (service) addHidden(form, 'm', 'service');
        addHidden(form, 'param_popup_yn', openPopup ? 'Y' : 'N');

        Object.entries(echo).forEach(([k, v]) => addHidden(form, k, v));

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form); // DOM 정리(선택)
    }


    /**
     * 뒤로가기 링크 액션
     */
    const handlOnBack = () => {
        const from = location.state?.from;
        if (from) {
            navigate(from, { replace: true }); // 히스토리 정리
        } else {
            //navigate(-1); // fallback: 그냥 한 단계 뒤로 하려면...
            navigate(URL.APP_SETTINGS, { replace: true });
        }
    };


    return (
        <>
            <HeadSub title="내 정보 수정" onBack={handlOnBack} />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['content-box']}>
                        <strong>기본 정보</strong>
                        <div className={style['inner-box']}>
                            <ul>
                                <li>
                                    <p>이름</p>
                                    <div className={style['right']}>
                                        <span>{loginUser?.usrNm}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>생년월일</p>
                                    <div className={style['right']}>
                                        {/* <span>1998.12.22</span> */}
                                        <span>{formatBrthdy(loginUser?.brthdy)}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>휴대전화번호</p>
                                    <div className={style['right']}>
                                        {/* <span>01012345678</span> */}
                                        <span>{loginUser?.mblNo}</span>
                                        <button className='btn' data-btn-type="fill-main" data-btn-size='xsmd'
                                            onClick={() => getIntegrationCryptoToken()}
                                        >
                                            <span>휴대전화번호 변경</span>
                                        </button>
                                    </div>
                                </li>
                                <li>
                                    <p>서비스 고유코드</p>
                                    <div className={style['right']}>
                                        <span>AFTCR{loginUser.usrInfoId}DGTP</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div className={style['content-box']}>
                        <strong>현재 로그인 정보</strong>
                        <div className={style['inner-box']}>
                            <ul>
                                <li>
                                    <p>로그인 수단</p>
                                    <div className={style['right']}>
                                        <span>아이디/비밀번호</span>
                                    </div>
                                </li>
                                <li>
                                    <p>아이디</p>
                                    <div className={style['right']}>
                                        <span>{loginUser?.usrId}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>비밀번호</p>
                                    <div className={style['right']}>
                                        <button className='btn' data-btn-type="fill-main" data-btn-size='xsmd' onClick={() => navigate(URL.CHANGE_PASSWORD)}>
                                            <span>비밀번호 변경</span>
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className={style['btn-group']}>
                                <button onClick={logOutBtn}>
                                    <span>로그아웃</span>
                                </button>
                                <button onClick={() => navigate(URL.MY_INFO_WITHDRAW)}>
                                    <span>탈퇴하기</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 정말 로그아웃하실 건가요?</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={() => setIsOpen(false)}>
                                <span>아니오</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleLogout}>
                                <span>네</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                />
            )}
        </>
    );
};

export default MyInfoWrite;
